import {defineMessages} from 'react-intl';

export default defineMessages({
    'mode': {
        defaultMessage: 'Mode',
        description: 'Mode menu item in the menu bar',
        id: 'gui.menuBar.modeMenu'
    },
    'normal': {
        defaultMessage: 'Normal mode',
        description: 'April fools: resets editor to not have any pranks',
        id: 'gui.menuBar.normalMode'
    },
    'cat': {
        defaultMessage: 'Caturday mode',
        description: 'April fools: Cat blocks mode',
        id: 'gui.menuBar.caturdayMode'
    },
    '90s': {
        defaultMessage: '90s mode',
        description: 'April fools: Makes the editor look like the 1990s',
        id: 'gui.menuBar.1990sMode'
    },
    'old': {
        defaultMessage: 'Old timey mode',
        description: 'April fools: Makes the editor look like an old movie projector', // eslint-disable-line max-len
        id: 'gui.menuBar.oldTimeyMode'
    },
    'prehistoric': {
        defaultMessage: 'Prehistoric mode',
        description: 'April fools: Makes the editor look like inside a cave',
        id: 'gui.menuBar.prehistoricMode'
    }
});
